import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  box-sizing: border-box;
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({
    theme: {
      color: { ui5 },
    },
  }) => ui5};
  clip-path: inset(0px); /* clip shadow */
  @media (max-width: 1440px), (max-height: 900px) {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
  }
`;
